// Atomic meta label helpers (address / coordinate / website classification)
// Pure functions extracted from FullscreenPoiModal

export const isAddressLabel = (lbl?: string): boolean => {
  if (!lbl) return false;
  const s = String(lbl).trim().toLowerCase();
  return s === '地址' || s === '地址：' || s === '地點' || s === '地点' || s === 'address' || s === 'addr' || s === '地址(address)';
};

export const isCoordinateLabel = (lbl?: string): boolean => {
  if (!lbl) return false;
  const s = String(lbl).trim().toLowerCase();
  return s === '坐标' || s === '坐標' || s === 'coordinates' || s === 'coordinate' || s === '经纬度' || s === '經緯度';
};
